import React, { ChangeEvent, useRef } from "react";

type UploadImageButtonProps = {
	onImageSelected: (fileName: string, base64Content: string) => void;
	buttonText?: string;
};

const UploadImageButton: React.FC<UploadImageButtonProps> = ({ onImageSelected, buttonText = "Upload Image" }) => {
	const [renewKey, setRenewKey] = React.useState(0);
	const inputRef = useRef<HTMLInputElement>(null);

	const handleButtonClick = () => {
		inputRef.current?.click();
	};

	const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
		setRenewKey((prevKey) => prevKey + 1); // Force re-render to reset input
		const file = e.target.files?.[0];
		if (!file) return;

		const reader = new FileReader();
		reader.onload = () => {
			const base64 = reader.result as string;
			onImageSelected(file.name, base64);
		};
		reader.readAsDataURL(file);
		// Reset input so the same file can be selected again
		e.target.value = "";
	};

	return (
		<span>
			<button type="button" onClick={handleButtonClick} className="flex">
				{buttonText}
				{!buttonText && (
					<span>
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
							<path
								d="M10 15V5M10 5L6 9M10 5l4 4"
								stroke="currentColor"
								strokeWidth="2"
								strokeLinecap="round"
								strokeLinejoin="round"
							/>
							<rect x="3" y="15" width="14" height="2" rx="1" fill="currentColor" />
						</svg>
					</span>
				)}{" "}
			</button>

			<input key={renewKey} ref={inputRef} type="file" accept="image/*" style={{ display: "none" }} onChange={handleFileChange} />
		</span>
	);
};

export default UploadImageButton;
